import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import onResize from './iframe-height-update';
import VTooltip from 'v-tooltip'

axios.defaults.headers.post[ 'Content-Type' ] = 'multipart/form-data'

window.addEventListener( 'load', () => {
    onResize();
    window.addEventListener( 'resize', onResize );
} );

Vue.use(VTooltip)
Vue.use( VueAxios, axios )
Vue.config.productionTip = false

new Vue( {
    vuetify,
    render : h => h( App )
} ).$mount( '#app' )